export const postForm = async (action, data = {}) => {
  const settings = {
    method: `POST`,
    body: JSON.stringify({ data })
  };
  try {
    const fetchResponse = await fetch(
      `${process.env.GATSBY_CMS_URL}${action}`,
      settings
    );

    return await fetchResponse.json();
  } catch (err) {
    return err;
  }
};

export const mapFieldGroups = (fieldGroups) =>
  fieldGroups.map(({ label, richText, fields }, groupIndex) => {
    const mappedFields = fields.map((field, fieldIndex) => {
      return {
        ...field,
        componentId: `field-${fieldIndex}`,
        fieldType:
          typeof field.fieldType === `string`
            ? JSON.parse(field.fieldType)
            : field.fieldType
      };
    });

    return {
      componentId: `field-group-${groupIndex}`,
      label,
      richText,
      fields: mappedFields
    };
  });

export const blobToBase64 = (blob) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};
